import ManageRequest from '../../../views/Personnel/Letter/ManageRequest.letter.view';

export default ManageRequest;
